export interface UserDocument {
  docUrl: string;
  id: string;
  uuid?: string;
  uploadedVia?: string;
}

export interface Document {
  id: number;
  docName: string;
  description: string;
  byDefault?: boolean;
  isMandatory?: boolean;
  userDocs?: UserDocument[];
  uploadedVia?: string;
  documentCategoryId?: number;
  docNameDms?: string;
}

export interface DocumentCategory {
  id: number;
  name: string;
  isMand: boolean;
  documents: Document[];
}

export enum UploadVia {
  Manual = "manual",
  Account_Aggregator_Manual = "account_aggregator_manual",
}

export interface ApplicantTabsProps {
  isApplicantTabsLoading: boolean;
  applicants: string[];
  tabsListLoading: boolean;
  applicationDetail: any[];
  mainApplicantDetails: any[];
  coApplicantDetails: any[];
  applicationId?: string;
  handleFetchApplicationDetail: () => void;
  partnerStartedJourney: boolean;
  enableCustomerJourney: boolean;
  setPartnerStartedJourney: any;
  hideHeaderActions?: boolean;
  headerActionsPortalTarget?: HTMLElement | null;
  headerActionsOnly?: boolean;
  disableHeaderActionsPortal?: boolean;
}

export type CoApplicantField = {
  id?: string | number;
  name: string;
  label?: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  options?: any;
  condition?: { field: string; value: any };
};
